import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-agri-business-finance-farmers.component.scss';
var FormItemAgriBusinessFinanceFarmers = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemAgriBusinessFinanceFarmers, _super);
    function FormItemAgriBusinessFinanceFarmers(element) {
        return _super.call(this, element) || this;
    }
    FormItemAgriBusinessFinanceFarmers.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = this.element.querySelector(".js-agri-business-finance-farmers__button");
    };
    FormItemAgriBusinessFinanceFarmers.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemAgriBusinessFinanceFarmers.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // additional containers
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        var postData = "";
        var serviceType = form.querySelector("input[name=serviceType]");
        if (serviceType) {
            postData += "service-type=" + serviceType.value;
        }
        var product = form.querySelector("input[name=product]");
        if (product) {
            postData += "&product=" + product.value;
        }
        var email = form.querySelector("input[name=email]");
        if (email) {
            postData += "&email=" + email.value;
        }
        var recipient = form.querySelector("input[name=recipient]");
        if (recipient) {
            postData += "&recipient=" + recipient.value;
        }
        var subject = form.querySelector("input[name=subject]");
        if (subject) {
            postData += "&subject=" + subject.value;
        }
        var description = form.querySelector("input[name=description]");
        if (description) {
            postData += "&description=" + description.value;
        }
        var redirect = form.querySelector("input[name=redirect]");
        if (redirect) {
            postData += "&redirect=" + redirect.value;
        }
        var _firstName = this.form.querySelector("input[name=firstName]");
        if (_firstName) {
            postData += "&firstname=" + _firstName.value;
        }
        var _lastName = this.form.querySelector("input[name=lastName]");
        if (_lastName) {
            postData += "&surname=" + _lastName.value;
        }
        var _phoneNumber = this.form.querySelector("input[name=phoneNumber]");
        if (_phoneNumber) {
            postData += "&contact=" + _phoneNumber.value;
        }
        var emailAddress = form.querySelector("input[name=emailAddress]");
        if (emailAddress) {
            postData += "&emailAddress=" + emailAddress.value;
        }
        var _deliveryAddress1 = this.form.querySelector("input[name=deliveryAddress1]");
        if (_deliveryAddress1) {
            postData += "&deliveryaddress1=" + _deliveryAddress1.value;
        }
        var _deliveryAddress2 = this.form.querySelector("input[name=deliveryAddress2]");
        if (_deliveryAddress2) {
            postData += "&deliveryaddress2=" + _deliveryAddress2.value;
        }
        var _deliveryAddress3 = this.form.querySelector("input[name=deliveryAddress3]");
        if (_deliveryAddress3) {
            postData += "&deliveryaddress3=" + _deliveryAddress3.value;
        }
        var _numberOfCopies = this.form.querySelector("input[name=numberOfCopies]");
        if (_numberOfCopies) {
            postData += "&numberofcopies=" + _numberOfCopies.value;
        }
        var _areaCode = this.form.querySelector("input[name=areaCode]");
        if (_areaCode) {
            postData += "&areacode=" + _areaCode.value;
        }
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var url = "/services/genericform.jsp";
        // service
        this.formsService.postForm(url, postData).then(function (response) {
            // Always show success message / no response from server (sending email)
            _this.analyticsService.dtmFormComplete("complete", response.code);
            loader.classList.remove("active");
            thankYou.classList.add("active");
            success.classList.add("active");
            error.classList.add("hidden");
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
        });
    };
    return FormItemAgriBusinessFinanceFarmers;
}(Base));
export { FormItemAgriBusinessFinanceFarmers };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-agri-business-finance-farmers/form-item-agri-business-finance-farmers.component.ts
// module id = 827
// module chunks = 0